import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import notificationService from "../../api/notificationServices";

export const getNotificationList = createAsyncThunk(
  "frontend/notifications-list",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await notificationService.notificationList(payload);
      return response.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch notifications",
      );
    }
  },
);
export const bulkUpdate = createAsyncThunk(
  "frontend/bulkUpdate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await notificationService.bulkUpdate(payload);
      return response.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(
        error.response?.data || "Failed to fetch notifications",
      );
    }
  },
);

export const getReadAllNotification = createAsyncThunk(
  "frontend/markReadAll-notifications",
  async (_, { rejectWithValue }) => {
    try {
      const response = await notificationService.MarkReadAllNotification();
      // console.log(response);
      return response.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(
        error.response?.data || "Failed to mark notifications as read",
      );
    }
  },
);
export const getNotificationPreferencesCategories = createAsyncThunk(
  "frontend/getNotificationPreferencesCategories",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await notificationService.getNotificationPreferencesCategories(
        payload,
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const notificationPreferences = createAsyncThunk(
  "frontend/notificationPreferences",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await notificationService.notificationPreferences(
        payload,
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const enableNotification = createAsyncThunk(
  "frontend/enableNotification",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await notificationService.enableNotification(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const disableNotification = createAsyncThunk(
  "frontend/disableNotification",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await notificationService.disableNotification(payload);
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const updateNotificationPreference = createAsyncThunk(
  "frontend/update-notification-preference",
  async ({ category, payload }, { rejectWithValue }) => {
    try {
      const response = await notificationService.updateNotificationPreference(
        category,
        payload,
      );

      return response.data;
    } catch (error) {
      console.log(error);

      return rejectWithValue(
        error.response?.data || "Failed to update notification preference",
      );
    }
  },
);

const initialState = {
  notificationList: {},
  readALLNotification: {},
  updateNotificationPreference: {},
  getNotificationPreferencesCategoriesItems: {},
  notificationPreferencesItems: {},
  disableNotificationItems: {},
  bulkUpdateItems: {},
  enableNotificationItems: {},
  isLoading: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",
  successMessage: "",
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getNotificationList.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(getNotificationList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.notificationList = action.payload.notificationList || {};
        state.successMessage =
          action.payload.message || "Notification Fetched Successfully";
        state.errorMessage = "";
      })
      .addCase(getNotificationList.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(getReadAllNotification.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.errorMessage = "";
      })
      .addCase(getReadAllNotification.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.readALLNotification = action.payload.readALLNotification || {};
        state.successMessage =
          action.payload.message || "Notification Read Successfully";
        state.errorMessage = "";
      })
      .addCase(getReadAllNotification.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.errorMessage = action.payload;
        state.successMessage = "";
      })
      .addCase(getNotificationPreferencesCategories.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(
        getNotificationPreferencesCategories.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.isSuccess = true;
          state.getNotificationPreferencesCategoriesItems =
            action.payload || "";
          state.errorMessage = "";
        },
      )
      .addCase(
        getNotificationPreferencesCategories.rejected,
        (state, action) => {
          state.isLoading = false;
          state.isError = true;
          state.errorMessage = action.payload;
        },
      )
      .addCase(notificationPreferences.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(notificationPreferences.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.notificationPreferencesItems = action.payload || "";
        state.errorMessage = "";
      })
      .addCase(notificationPreferences.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(bulkUpdate.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(bulkUpdate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.bulkUpdateItems = action.payload || "";
        state.errorMessage = "";
      })
      .addCase(bulkUpdate.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(enableNotification.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(enableNotification.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.enableNotificationItems = action.payload || "";
        state.errorMessage = "";
      })
      .addCase(enableNotification.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })

      .addCase(disableNotification.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.errorMessage = "";
      })
      .addCase(disableNotification.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.disableNotificationItems = action.payload || "";
        state.errorMessage = "";
      })
      .addCase(disableNotification.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(updateNotificationPreference.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
      })

      .addCase(updateNotificationPreference.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.updateNotificationPreference = action.payload || {};
        state.successMessage =
          action.payload.message || "Notification Preference Updated";
      })

      .addCase(updateNotificationPreference.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.errorMessage = action.payload;
      });
  },
});

export default notificationSlice.reducer;
